/* Visible content remains available without JavaScript. Dice have their own film controller. */
(() => {
  if (window.dopeVisualStory) return;
  window.dopeVisualStory = true;
  const filmOnly = document.currentScript?.hasAttribute('data-story-film-only') || false;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Set();
  const observed = new WeakSet();
  const filmSelector = 'video-media[data-story-media], [data-story-film-section] video-media:not([host])';
  const films = new Set();
  const filmVisibility = new WeakMap();
  const inPicture = video => document.pictureInPictureElement === video || video.webkitPresentationMode === 'picture-in-picture';
  const inFullscreen = video => document.fullscreenElement?.contains(video) || video.webkitPresentationMode === 'fullscreen';
  const pauseFilm = (media, reason) => {
    for (const video of media.querySelectorAll('video')) {
      if (reason !== 'replace' && reason !== 'unload' && inPicture(video)) continue;
      if (reason === 'offscreen' && inFullscreen(video)) continue;
      video.pause();
    }
  };
  const filmObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      filmVisibility.set(entry.target, entry.isIntersecting);
      if (!entry.isIntersecting) pauseFilm(entry.target, 'offscreen');
    }
  }, {threshold: 0}) : null;
  const selector = '[data-story-reveal], .template-index .dope-hero__caption, .template-index .dope-hero .slideshow, .template-index .dope-campaign__feature, .template-index .dope-courtside__intro, .template-index .dope-section-heading';
  const reveal = element => {
    if (reduced.matches || document.hidden || !element.isConnected || !element.animate) return;
    const animation = element.animate([{transform: 'translateY(20px)', opacity: .35}, {transform: 'translateY(0)', opacity: 1}], {duration: 650, easing: 'cubic-bezier(.2,.7,.25,1)'});
    running.add(animation);
    animation.finished.catch(() => {}).finally(() => running.delete(animation));
  };
  const observer = !filmOnly && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      reveal(entry.target);
    }
  }, {threshold: .12}) : null;
  const mount = root => {
    if (!filmOnly) root.querySelectorAll(selector).forEach(element => {
      if (observed.has(element)) return;
      observed.add(element);
      observer?.observe(element);
    });
    root.querySelectorAll(filmSelector).forEach(media => {
      if (films.has(media)) return;
      films.add(media);
      filmObserver?.observe(media);
    });
  };
  mount(document);
  document.addEventListener('play', event => {
    const video = event.target;
    if (video.tagName !== 'VIDEO') return;
    const media = video.closest(filmSelector);
    if (!films.has(media)) return;
    const unavailable = document.hidden || video.closest('[hidden]') || filmVisibility.get(media) === false && !inFullscreen(video);
    if (unavailable && !inPicture(video)) {
      video.pause();
      return;
    }
    for (const other of films) if (other !== media) pauseFilm(other, 'replace');
  }, true);
  const recheckFilms = () => {
    for (const media of films) {
      if (document.hidden) pauseFilm(media, 'hidden');
      else if (filmVisibility.get(media) === false) pauseFilm(media, 'offscreen');
    }
  };
  for (const event of ['leavepictureinpicture', 'fullscreenchange', 'webkitpresentationmodechanged']) {
    document.addEventListener(event, recheckFilms, true);
  }
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (!filmOnly) event.target.querySelectorAll(selector).forEach(element => observer?.unobserve(element));
    for (const animation of running) if (event.target.contains(animation.effect?.target)) animation.cancel();
    for (const media of films) {
      if (!event.target.contains(media)) continue;
      pauseFilm(media, 'unload');
      filmObserver?.unobserve(media);
      films.delete(media);
      filmVisibility.delete(media);
    }
  });
  const settle = () => { for (const animation of running) animation.cancel(); };
  reduced.addEventListener('change', () => { if (reduced.matches) settle(); });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    settle();
    for (const media of films) pauseFilm(media, 'hidden');
  });
})();
